import angular from "angular";
import Swal from "sweetalert2";

angular
	.module('app')
	.component('contractModal', {
		template: require('./contract-modal.html'),
        controller: ['$http', 'Auth', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });
            
function controller($http, Auth) {
        
	let $ctrl = this;
	
	$ctrl.$onInit = function () {
        $ctrl.user = Auth.user();
    };

    $ctrl.accept = function () {
        $http
            .post('/accept-contract')
            .then(res => {
                Swal.fire({
                    icon: 'success',
                    text: 'Келісім сақталды'
                }).then(() => {
                    $ctrl.close();
                })
            })
            .catch(err => {

            });
    };
}